import React from 'react';
import {View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {useAppDispatch} from '../../../../redux';
import {useNavigation} from '@react-navigation/native';

import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize, maxDesktopContentWidth} from '../../../../shared/theme/helpers';
import {images} from '../../../../assets/icons';
import {VisuallyImpairedDesktop} from '../../../../shared/components/visuallyImpairedDesktop';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {IconLinkLogin} from './components/iconLinkLogin';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {Screens} from '../../../../shared/routing';
import {changeThemeProperty} from '../../../../redux/actions/runtime/theme';
import {VisImpStatus} from '../../../../shared/models/visuallyImpairedSettings';
import {formatPhone, openExternalLink, openExternalPhone} from '../../../../shared/pipes';

export default ({visuallyImpairedSettings, content, safeArea = true}: Props) => {
  const isDesktop = useIsDesktop();
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const styles = useStyles(({mediaOnly}) => ({
    container: {
      alignSelf: 'center',
      paddingHorizontal: 20,
      paddingTop: 20,
      width: '100%',
      maxWidth: maxDesktopContentWidth,
    },
    content: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    leftBlock: {
      marginRight: 'auto',
    },
    rightBlock: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginLeft: 30,
        },
        {
          marginLeft: 20,
        },
      ),
    },
  }));
  const visActive = !!visuallyImpairedSettings?.visuallyImpaired;
  const HeaderSafeArea = safeArea ? SafeAreaView : View;
  return (
    <HeaderSafeArea>
      <ResponsiveView only={[DeviceSize.desktop]}>
        <VisuallyImpairedDesktop active={visActive} />
      </ResponsiveView>
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.leftBlock}>
            <IconLinkLogin
              icon={images.Up}
              label='Портал ЕСК'
              testIdPrefix='esk-portal-header'
              iconHeight={20}
              iconWidth={20}
              onPress={async () => {
                await openExternalLink(content.esksoContacts.website);
              }}
            />
          </View>
          <View style={styles.rightBlock}>
            <IconLinkLogin
              icon={images.Phone}
              testIdPrefix='support-phone-header'
              iconWidth={22}
              iconHeight={22}
              label={isDesktop ? formatPhone(content.esksoContacts.supportPhone) : null}
              onPress={async () => await openExternalPhone(content.esksoContacts.supportPhone)}
            />
          </View>
          <View style={styles.rightBlock}>
            <IconLinkLogin
              onPress={() => {
                if (!isDesktop) {
                  dispatch(changeThemeProperty('visuallyImpaired', VisImpStatus.Active));
                  navigation.navigate(Screens.VisuallyImpairedSettings);
                } else {
                  dispatch(
                    changeThemeProperty('visuallyImpaired', visActive ? VisImpStatus.Disabled : VisImpStatus.Active),
                  );
                }
              }}
              iconWidth={24}
              iconHeight={24}
              icon={images.Eye as any}
              testIdPrefix='eye-label'
              label={isDesktop ? (visActive ? 'Обычная версия' : 'Версия для слабовидящих') : null}
            />
          </View>
        </View>
      </View>
    </HeaderSafeArea>
  );
};
